module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/is-pure.js
// module id = 32
// module chunks = 0 1